export default "__VITE_ASSET__DVqlNzxl__"